import request from './request';
import type { RegionalRecommendationResponse } from '../types/regionalRecommendation';

export const getRegionalRecommendations = async (
  regions?: string[],
  allRegions: boolean = false,
  limitPerOperator: number = 2,
): Promise<RegionalRecommendationResponse> => {
  return request({
    url: '/api/products/regional-recommendations',
    method: 'GET',
    params: {
      regions: allRegions ? 'all' : regions?.join(',') || undefined,
      limitPerOperator,
    },
  });
};
